import { Injectable } from '@angular/core';
import { AcceptanceService, EntityArrayResponseType } from './acceptance.service';
import { HttpClient } from '@angular/common/http';
import { ApplicationConfigService } from './application-config.service';
import { Observable } from 'rxjs';
import { createRequestOption } from '../app/shared/util/request-util';
import { IAcceptance } from '../models/acceptance.model';
import { TableOptions } from './i-bary-table-fetch-service';
import { ApiProviderService } from './api-provider.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';

@Injectable({ providedIn: 'root' })
export class AcceptanceExtendedService extends AcceptanceService {
  protected endPoint = API_ENDPOINTS.ACCEPTANCES;

  constructor(protected apiProvider: ApiProviderService, protected override http: HttpClient, protected override applicationConfigService: ApplicationConfigService) {
    super(http, applicationConfigService);
  }

  override query(req?: any, tableOption?: TableOptions): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    let url = this.endPoint;
    if (tableOption?.appendPath) {
      url += tableOption.appendPath;
    }
    if (tableOption?.identifier) {
      url += '/' + tableOption.identifier;
    }
    return this.apiProvider.publicGet<IAcceptance[]>(url, { params: options, observe: 'response' });
  }

  override delete(offerId?: number): Observable<EntityArrayResponseType> {
    return offerId ? this.apiProvider.delete<IAcceptance[]>(this.endPoint + '/' + offerId) : this.apiProvider.delete<IAcceptance[]>(this.endPoint);
  }
}
